import { render, staticRenderFns } from "./TextBubble.vue?vue&type=template&id=6c08694b&"
import script from "./TextBubble.vue?vue&type=script&lang=ts&"
export * from "./TextBubble.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports